export default __webpack_public_path__ + "static/media/circular-logo.0e1d1b5f.svg";